(function() {
    'use strict';

    var CertificateofComplianceCtrl = function($scope, $compile, $uibModalInstance, ajaxCall, passedModel, xmsNotificationFactory) {

        console.log("Inside CertificateofCompliance");

        if( !angular.isDefined(passedModel) ){
            passedModel = {};
        }
        $scope.cocModel = passedModel

       $scope.fnSave = function($event) {
            $event.preventDefault();
            var ajaxUrl = WEBAPP_PATH + "/screening/saveCertificateofCompliance?";
            var data = $scope.cocModel;
            console.log(data)
            ajaxCall.getData(ajaxUrl, data).then(
                function(result) {
                    xmsNotificationFactory.addObj({id: "cocPop", type: result.data.responseType, bodyHtml: result.data.responseMessage, timeout:10});
                    $uibModalInstance.close($scope.cocModel);
                },
                function(result) {
                    var alertMessage = "Error occurred. Please try again later..";
                    xmsNotificationFactory.addObj({id: "cocPop", type: "danger", bodyHtml: alertMessage, timeout:10});
                    $uibModalInstance.close($scope.confirmationModel);
                }
            );
            $event.preventDefault();
        }

        $scope.cancelPop = function($event) {
            $event.preventDefault();
            $uibModalInstance.dismiss('cancel');
        }

        $scope.cancel = function() {
           $uibModalInstance.dismiss('cancel');
        }


    }
    CertificateofComplianceCtrl.$inject = ['$scope', '$compile', '$uibModalInstance','ajaxCall','params','xmsNotificationFactory'];
    angular.module('app').controller('CertificateofComplianceCtrl', CertificateofComplianceCtrl);

}());